import React from 'react';
import { Button as BsButton } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IButtonProps {
    text?: string;
    click?: () => void;
    width?: string;
    minWidth?: string;
    type?: string;
    marginRight?: string;
    marginLeft?: string;
    icon?: any;
    colorIcon?: string;
    sizeIcon?: any;
    disabled?: boolean;
    title?: string;
    borderRadius?: string;
    height?: string;
    minHeight?: string;
    marginTop?: string;
    marginBottom?: string;
    actionName?: string;
}

export const Button: React.FC<IButtonProps> = ({
    text,
    click,
    width,
    minWidth,
    type,
    marginRight,
    marginLeft,
    icon,
    colorIcon,
    sizeIcon,
    disabled,
    title,
    borderRadius,
    height,
    minHeight,
    marginTop,
    marginBottom,
    actionName,
}) => {

    type = type || 'primary';

    let style: any = {
        width:width||'auto',
        minWidth:minWidth||'0px',
        marginRight:marginRight||'0px',
        marginLeft:marginLeft||'0px',
        marginTop:marginTop||'0px',
        marginBottom:marginBottom||'0px'
    };

    if (borderRadius) {
        style = { ...style, borderRadius: borderRadius };
    }

    if (height || minHeight) {
        style = { ...style, height: height || minHeight, minHeight: minHeight || height };
    }

    return (
        <BsButton
            variant={`outline-${type}`}
            onClick={click}
            style={style}
            disabled={disabled}
            title={title}
            data-action-name={actionName}
        >
            {icon ? <FontAwesomeIcon icon={icon} color={colorIcon || '#000'} size={sizeIcon || 'sm'} /> : null}
            {text}
        </BsButton>
    );
}